/**
 * QuestionControlsDirective class handles the directive for question controls.
 * It manages the initialization of the directive and its controller, as well as
 * the logic for button clicks and bookmarking.
 */
class QuestionControlsDirective {
    /**
     * Constructor for QuestionControlsDirective.
     * @param {Object} $compile - AngularJS compile service.
     * @param {Object} $bridges - Custom service for bridge operations.
     */
    constructor($compile, $bridges) {
        this._logIdentifier = 'QuestionControlsDirective';
        this.$compile = $compile;
        this.$bridges = $bridges;
    }

    /**
     * Returns the directive definition object.
     * @returns {Object} Directive definition object.
     */
    getDirective() {
        return {
            restrict: 'E',
            replace: true,
            templateUrl: '/views/ib/components/QuestionControlsDirective.html',
            controller: ['$scope', '$element', 'TaskDataService', ($scope, $element, TaskDataService) => {
                this.initializeController($scope, $element, TaskDataService);
            }]
        };
    }

    /**
     * Initializes the controller for the directive.
     * @param {Object} $scope - AngularJS scope.
     * @param {Object} $element - jQuery element.
     * @param {Object} TaskDataService - Service for task data operations.
     */
    initializeController($scope, $element, TaskDataService) {
        var uuid = $scope.uuid;
        var taskContext = TaskDataService.fetchContext();

        $scope.questionPart = taskContext.read(uuid);

        /**
         * Handles the click event for the finish button.
         */
        $scope.onFinishButtonClick = () => {
            var questionPartUUID = $element.attr('uuid'),
                questionPart = taskContext.read(questionPartUUID),
                questionStatus = questionPart.getStatus(),
                targetSelector = $element.find('button.question-finish-button'),
                finishStatus = 1,
                startedStatus = 0.5;

            if (questionStatus !== finishStatus) {
                questionPart.setStatus(finishStatus);
                targetSelector.removeClass('unlock');
            } else {
                questionPart.setStatus(startedStatus);
                targetSelector.addClass('unlock');
            }
        };

        /**
         * Handles the click event for the bookmark button.
         */
        $scope.onBookmarkButtonClick = () => {
            var questionPartUUID = $element.attr('uuid'),
                questionPart = taskContext.read(questionPartUUID),
                isBookmarked = questionPart.isBookmarked(),
                targetSelector = $element.find('button.question-bookmark-button');

            questionPart.setIsBookmarked(!isBookmarked);

            if (questionPart.isBookmarked()) {
                targetSelector.addClass('unbookmark');
            } else {
                targetSelector.removeClass('unbookmark');
            }

            questionPart.save();
        };

        var clearfix = $('<div></div>').addClass('clearfix'),
            containerSelector = '.row div.question-box',
            controlsSelector = 'div.question-button-bar',
            clearFixSwitch = 'fix-cleared';

        $(containerSelector).each(function() {
            var that = $(this);
            var isClearFixed = that.find(controlsSelector).attr(clearFixSwitch);
            if (typeof isClearFixed === 'undefined') {
                that.find(controlsSelector).before(clearfix.clone());
                that.find(controlsSelector).after(clearfix.clone());
                that.find(controlsSelector).attr(clearFixSwitch, 'true');
            }
        });
    }
}

export default QuestionControlsDirective;